import { CREST_INNER, CREST_OUTER } from "../../BrandCrest/paths";

export const LOGO_VIEWBOX = { w: 456.38, h: 494 };
export const LOGO_CENTER = { x: 228.19, y: 247 };
export const LOGO_SCALE = 247;

// path 0: inner features (W core, brow band, cheeks)
// path 1: outer ring (outer + inner outline, evenodd)
export const LOGO_PATHS = [CREST_INNER, CREST_OUTER];
